import { IMAGE_SERVICE_URL, BASE_URL } from 'app/config';

export const HeroImage = (): JSX.Element => {
  const imageUrl = 'assets/tradein/vw-golf-blue.webp';
  return (
    <img
      src={`${IMAGE_SERVICE_URL as string}/unsafe/1024x/filters:quality(90)/${
        BASE_URL as string
      }/${imageUrl}`}
      alt="Ein blauer VW Golf"
      title="tradein-hero-image"
    />
  );
};
